import { LockAIcon } from '@prophecy/icons';
import { BaseColor, theme } from '@prophecy/theme';
import { Stack } from '@prophecy/ui-v3';
import { Badges } from '@prophecy/ui-v3/Badges';

import { SapMeteringInfo } from './apiTypes';
import { CapacityConsumptionCard } from './CapacityConsumptionCard';
import { CategoryMetricCards } from './CategoryMetricCards';
import { CuBreakdown } from './CuBreakdown';
import { SeatsSection } from './SeatsSection';
import { AdminOnlyRule } from './styled';
import { UsageByEnvironment } from './UsageByEnvironment';
import { useSapUsageDashboard } from './useSapUsageDashboard';

export function SapUsageDashboard({
  meteringInfo,
  isAdmin,
  onRequestCapacity,
  onAddUsers
}: {
  meteringInfo: SapMeteringInfo;
  isAdmin: boolean;
  onRequestCapacity?: () => void;
  onAddUsers: () => void;
}) {
  const data = useSapUsageDashboard(meteringInfo);

  return (
    <Stack gap={theme.spaces.x24} data-test-id='sap-usage-dashboard'>
      <CapacityConsumptionCard data={data} onRequestCapacity={onRequestCapacity} />
      <CategoryMetricCards categories={data.categories} />
      <CuBreakdown data={data} />

      {isAdmin && (
        <>
          <Stack direction='horizontal' gap={theme.spaces.x12} alignY='center'>
            <Badges
              size='m'
              variant='pillLight'
              tone={BaseColor.primary}
              iconPlacement='left'
              icon={<LockAIcon type='default' size='xs' />}>
              Admin only
            </Badges>
            <AdminOnlyRule />
          </Stack>
          <UsageByEnvironment data={data} />
          <SeatsSection seats={data.seats} onAddUsers={onAddUsers} />
        </>
      )}
    </Stack>
  );
}
